import { ym } from "@/utils/metrika"
import JoinTribeButton, { TelegramIconLink } from "./JoinTribeButton"
import Box from "@mui/material/Box"
import Toolbar from "@mui/material/Toolbar"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { MenuButton } from "./HeaderMenu/MenuButton/MenuButton"
import { HeaderIcons } from "./HeaderProfile/HeaderIcons"
import HeaderSearch from "./HeaderSearch"
import {
  headerCont,
  headerLeftCont,
  headerRightCont,
  headerStyle,
  logoLink,
} from "./headerNavStyles"
import logo from "/src/assets/svg/header-icons-pack/logo-icon.svg"
import BackArrow from "/src/assets/svg/promotion-icon/back-arrow.svg?react"
import PromoTitle from "/src/assets/svg/promotion-icon/promotion-title.svg?react"
import GetButton from "./GetButton";

const navLinkStyle = {
  fontSize: "14px",
  fontWeight: 600,
  color: "var(--header-text)",
  textDecoration: "none",
  padding: "6px 14px",
  borderRadius: "100px",
  transition: "background 0.18s",
  whiteSpace: "nowrap" as const,
}

const Header = () => {
  const screenUserWidth = window.screen.width
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const isPromo = pathname.startsWith("/profile/promotion")

  return (
    <Box sx={headerCont}>
      <Toolbar sx={headerStyle}>
        <Box sx={headerLeftCont}>
          <BackArrow
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer", display: !isPromo ? "none" : "block" }}
          />

          <MenuButton />

          {screenUserWidth > 759 && (
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <Link to="/" style={logoLink}>
                <img src={logo} alt="Логотип Tribe" style={{ maxHeight: "100%", maxWidth: "100%" }} />
              </Link>

              <PromoTitle
                style={{
                  alignSelf: "end",
                  marginBottom: "3px",
                  width: "64px",
                  display: !isPromo ? "none" : "block",
                }}
              />

              {!isPromo && (
                <>
                  <Link to="/about" style={navLinkStyle}>
                    Зачем мы
                  </Link>
                  <Link to="/documents" style={navLinkStyle}>
                    Документы
                  </Link>
                </>
              )}
            </Box>
          )}
        </Box>

        <Box sx={headerRightCont}>
          {/* Яркая кнопка «Вступай в Племя» — видна и на телефоне */}
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {screenUserWidth > 759 && <TelegramIconLink />}
            <JoinTribeButton />
          </Box>
          {screenUserWidth > 759 && (
            <Box sx={{ display: "flex", alignItems: "center", gap: "6px", opacity: 0.6 }}>
              <a
                href="https://play.google.com/store/apps/details?id=com.covenant.tribe"
                target="_blank"
                rel="noopener noreferrer"
                title="Скачать в Google Play"
                onClick={() => ym.appStoreClick()}
                style={{ display: "flex", alignItems: "center" }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="var(--header-text)">
                  <path d="M3.18 23.76c.3.17.64.24.99.2l12.6-11.53-2.83-2.83L3.18 23.76zm16.4-13.04L16.9 9.1 3.85.45C3.48.22 3.06.17 2.7.37L14.94 12.6l4.64-1.88zM22.1 10.3c-.42-.25-.9-.25-1.32 0l-2.06 1.06 2.34 2.34 1.04-.53c.73-.43.73-1.44 0-1.87zm-19.4 1.04l10.76 9.84-2.83-2.83L2.7 23.63c-.36-.19-.7-.6-.7-1.11V1.48c0-.5.34-.92.7-1.11z"/>
                </svg>
              </a>
              <a
                href="https://www.rustore.ru/catalog/app/com.covenant.tribe"
                target="_blank"
                rel="noopener noreferrer"
                title="Скачать в RuStore"
                style={{ display: "flex", alignItems: "center" }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="var(--header-text)">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/>
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-5h2v2h-2zm0-8h2v6h-2z"/>
                </svg>
              </a>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); alert("Приложение для iOS скоро будет доступно в App Store!") }}
                title="App Store — скоро"
                style={{ display: "flex", alignItems: "center", opacity: 0.5, cursor: "pointer" }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="var(--header-text)">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
              </a>
            </Box>
          )}
          {screenUserWidth > 759 && <GetButton />}
          <HeaderSearch />
          <HeaderIcons />
        </Box>
      </Toolbar>
    </Box>
  )
}

export default Header
